"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const forgot_password_1 = require("@Entities/schemas/user/forgot-password");
const zod_1 = require("@hookform/resolvers/zod");
const common_1 = require("@Const/common");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const Form_1 = __importDefault(require("@App/kit/fields/v2/Form"));
const mobx_react_1 = require("mobx-react");
const HttpError_1 = require("@App/exceptions/HttpError");
const clsx_1 = __importDefault(require("clsx"));
const ChangePasswordStep = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { authStore, popupStore, preloaderStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { username, setHasBeenUpdated } = props;
    const isLoggedIn = !username;
    const [badResponse, setBadResponse] = (0, react_1.useState)(undefined);
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        resolver: (0, zod_1.zodResolver)(forgot_password_1.changePasswordSchema.refine((data) => data.code !== (badResponse === null || badResponse === void 0 ? void 0 : badResponse.code), {
            path: ['code'],
            message: badResponse === null || badResponse === void 0 ? void 0 : badResponse.message,
        })),
    });
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        try {
            username
                ? yield authStore.confirmForgotPassword(username, data.code, data.password)
                : yield userStore.changeUserPassword(data.code, data.password);
        }
        catch (e) {
            preloaderStore.openTransparentPreloader(false);
            if (e instanceof Error || e instanceof HttpError_1.HttpError) {
                setBadResponse({ code: data.code, message: e.message });
            }
            else {
                setBadResponse({ code: data.code, message: 'Something has gone wrong.' });
            }
            return;
        }
        popupStore.setAlertData('Password updated!', false);
        preloaderStore.openTransparentPreloader(false);
        setHasBeenUpdated && setHasBeenUpdated(true);
        if (!isLoggedIn) {
            navigate('/login');
        }
    });
    (0, react_1.useEffect)(() => {
        methods.trigger().then();
    }, [badResponse]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, clsx_1.default)('change-password', isLoggedIn !== null && isLoggedIn !== void 0 ? isLoggedIn : 'logged-in') },
            react_1.default.createElement("h3", null, username ? 'Forgot password' : 'Change Password'),
            react_1.default.createElement("p", null, "We've attempted to email you a password reset code. Please check your email and enter the code below before selecting a new password."),
            react_1.default.createElement(Form_1.default, { onSubmit: onSubmit, submitButtonLabel: "Confirm Password Reset", formFields: forgot_password_1.changePasswordFormFields, methods: methods, icon: common_1.ICONS.arrow_forward, disableSubmit: !methods.formState.isValid }))));
};
exports.default = (0, mobx_react_1.observer)(ChangePasswordStep);
